module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Настройки тестирования")]), _vm._v(" "), _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveInterval($event)
      }
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "interval"
    }
  }, [_vm._v("Интервал между попытками пройти тест в часах:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interval),
      expression: "interval"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "id": "interval"
    },
    domProps: {
      "value": (_vm.interval)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.interval = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_vm._v("Сохранить")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-943a0792"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Test/Index.vue
// module id = 984
// module chunks = 0